/*** IMPORTS FROM imports-loader ***/
(function() {

// TODO: Reconsider this module name since we're really returning the PIP module
// that also happens to establish product data.
define(['pip-customer', 'window'],
  function (pipCustomer, window) {

    var instance;

    function PIP() {
      this.products = {
        primary: {}
      };

      this.customer = new pipCustomer();

      this.viewModel = {
        buybelt: {},
        page: {},
        badging: {}
      };

      this.flags = [];
      this.debugMode;
      this.remoteHosts = {};
      this.errorState = false;
      if (window.location.search.indexOf('debug') !== -1) {
        this.debugMode = true;
        console.log('PIP: ', this);
      }

      if (window.location.search.indexOf('test=true') !== -1) {
        this.testMode = true;
      }

    }

    PIP.prototype.update = function update(data) {
      this.products.primary.data = data.primaryItemData;
      this.experience = data.experience;
      this.experienceFlavor = data.experienceFlavor;
      this.features = data.featureState || {};
      this.platform = data.channel;
      // temporary fix — THD not recognizing tablet as a valid experience
      this.platformForCart = (data.channel && data.channel.toLowerCase() === "mobile") ? "mobile" : "desktop";
      this.fulfillment = data.fulfillment;
      this.inventory = data.inventory;
      this.pipCheckoutOptions = data.pipCheckoutOptions;
      this.remoteHosts = data.remoteHosts;
      this.protectionPlan = data.protectionPlan;
      this.shippingExclusion = data.shippingExclusion;
      this.multiSkuBulkPromotion = data.multiSkuBulkPromotion;
      this.installServices = data.installServices;
      this.subscribeAndSaveEligible = data.subscribeAndSaveEligible;
      this.serviceAddOns = data.serviceAddOns;
      this.inStoreAssemblyAvailable = data.inStoreAssemblyAvailable;
      this.doItYourself = data.doItYourself;
      this.isB2BCustomer = data.b2BCustomer;
      this.env = data.env;
      this.bazaarVoiceFrontEndKey = data.bazaarVoiceFrontEndKey;
      this.movingCalculatorEligible = data.movingCalculatorEligible;
      this.showBopisExperienceForMajorAppliance = data.showBopisExperienceForMajorAppliance;
      this.eventMetadata = data.eventMetadata;

      if (this.features.llcMockDataServiceEnabled && data.mockServicesData) {
        this.mockServicesData = data.mockServicesData;
      }

      // THD-CALCULATORS
      this.projectCalculatorEligible = data.projectCalculatorEligible;
      this.overageMultiplierEligible = data.overageMultiplierEligible;
      if (this.features && this.features.linkOverageToApiEnabled && data.overagePercentage !== null) {
        this.overagePercentage = data.overagePercentage;
      }

      this.superSkuItem = data.primaryItemData.itemExtension.superSkuItem;
      this.corporateInformation = data.corporateInformation;

      if (this.features.multistoreFeatureEnabled) {
        this.isAnchorStore = data.anchorStore;
      }

      if (this.features.multistoreFeatureEnabled && data.nearbyStore) {
        this.nearbyStore = data.nearbyStore;
        this.nearbyStore.distance = data.nearbyStore.distance ? parseFloat(data.nearbyStore.distance).toFixed(1) : '';
      }

      if (data.localStore) {
        this.customer.isLocalized = true;
        this.customer.localStore = data.localStore;

        if (this.features.multistoreFeatureEnabled && data.nearbyStore) {
          this.customer.storeForPurchase = this.nearbyStore.storeId;
        } else {
          this.customer.storeForPurchase = this.customer.localStore.storenumber;
        }
      }

      if (data.fulfillment.appliance) {
        this.fulfillment.appliance.availability = {
          ATCButtonEnabled: true
        };
      }

      if (this.fulfillment.store
        && this.fulfillment.store.buyOnlineShipToStore
        && this.fulfillment.shipping
        && this.fulfillment.shipping.shipToHome
        && this.inventory.online.isBackordered) {
        this.inventory.isSharedBackordered = true
      }

      if (data.fulfillment.store) {
        this.fulfillment.store.fulfillmentType = null;
        if (this.fulfillment.store.buyOnlinePickUpInStore) {
          this.fulfillment.store.fulfillmentType = 'BOPIS';
        } else if (this.fulfillment.store.buyOnlineShipToStore) {
          this.fulfillment.store.fulfillmentType = 'BOSS';
        }
      }

      if (data.fulfillment.shipping && data.fulfillment.shipping.shipToHome) {

        if(data.fulfillment.shipping.shipToHome.dynamicEtaOptimalDate) {
          this.fulfillment.shipping.shipToHome.estimatedDeliveryDate = data.fulfillment.shipping.shipToHome.dynamicEtaOptimalDate;
        } else if (data.fulfillment.shipping.shipToHome.conversationalEstimatedShippingStartDate && data.fulfillment.shipping.shipToHome.conversationalEstimatedShippingEndDate) {
          if (data.fulfillment.shipping.shipToHome.conversationalEstimatedShippingStartDate === data.fulfillment.shipping.shipToHome.conversationalEstimatedShippingEndDate) {
            this.fulfillment.shipping.shipToHome.estimatedDeliveryDate = data.fulfillment.shipping.shipToHome.conversationalEstimatedShippingStartDate;
          }
        } else if (data.fulfillment.shipping.shipToHome.estimatedShippingStartDate && data.fulfillment.shipping.shipToHome.estimatedShippingEndDate) {
          if (data.fulfillment.shipping.shipToHome.estimatedShippingStartDate === data.fulfillment.shipping.shipToHome.estimatedShippingEndDate) {
            this.fulfillment.shipping.shipToHome.estimatedDeliveryDate = data.fulfillment.shipping.shipToHome.estimatedShippingStartDate;
          }
        }
        if (data.fulfillment.shipping.shipToHome.dynamicEta) {
          this.fulfillment.shipping.shipToHome.dynamicEta.totalMinutes = parseInt(data.fulfillment.shipping.shipToHome.dynamicEta.minutes, 10) + (parseInt(data.fulfillment.shipping.shipToHome.dynamicEta.hours, 10) * 60);
        }
      }

      this.viewModel.page.hasTabs = !!document.querySelector('.has-tab-layout');

    };

    PIP.prototype.updatePackages = function updatePackages(data) {
      if (data.packageModel) {
        this.packageModel = data.packageModel;
      } else {
        this.error = data.error;
        this.errorState = true;
        this.packageId = data.packageId;
      }
      this.experience = data.experience;
      this.features = data.featureState || {};
      this.platform = data.channel;
      this.platformForCart = (data.channel && data.channel.toLowerCase() === "mobile") ? "mobile" : "desktop";
      this.isB2BCustomer = data.b2BCustomer;

      if (this.features.llcMockDataServiceEnabled && data.mockServicesData) {
        this.mockServicesData = data.mockServicesData;
      }
    }

    PIP.prototype.addParameter = function addParameter(name, value) {
      if (!this[name]) {
        this[name] = value;
      } else {
        console.error('Unable to add new parameter to PIP! "' + name + '" already exists!');
      }
    };

    PIP.prototype.setFlag = function setFlag(name, value) {
      this.flags[name] = value;
    };

    PIP.prototype.addProduct = function addProduct(name, value) {
      if (!this.products[name]) {
        this.products[name] = value;
      } else {
        console.error('Unable to add new product! Product "' + name + '" already exists!');
      }
    };

    function getPIP() {
      if (!instance) {
        instance = new PIP();
      }
      return instance;
    }

    return getPIP();

  });

}.call(window));